import AxiosWrapper from "~/assets/javascript/AxiosWrapper";
import { updateField, getField } from 'vuex-map-fields'
import { translate } from '~/assets/javascript/localization/Localization'

const getDefaultState = () => ({
    audit_questionnaire_revisions: null,
    questionnaire: null,
    publisher: [],
    permissions: {},
    can_approve: null,
    can_disapprove: null,
    can_make_live: null,
    can_send_approval: null,
})

export const state = getDefaultState

export const mutations = {
    setStateFromResponse(state, res) {
        Object.keys(state).forEach(key => {
            state[key] = res[key];
        });
    },
    deleteQuestionnaireRevision(state, questionnaireRevision) {
        state.audit_questionnaire_revisions.splice(state.audit_questionnaire_revisions.indexOf(questionnaireRevision), 1)
    },
    updateField
}

export const getters = {
    getField,
    editQuestionnaireUrl: (state) => (questionnaireRevision) => {
        return `/audit/questionnaires/${questionnaireRevision.id}/edit`
    },
    breadcrumbs(state) {
        const groupId = state.questionnaire?.audit_questionnaire_group_id
        return [
            { text: translate('questionnaire_groups'), path: '/audit/questionnaire_groups' },
            {
                text: translate('questionnaires'), path: `/audit/questionnaire_groups/${groupId}/questionnaires`
            },
            { text: translate('revisions') },
        ]
    }
}

export const actions = {

    async initRevisions({ state, commit, dispatch }, params) {
        const questionnaireId = params['id']
        AxiosWrapper.get(`/data_api/v0/audit/questionnaires/${questionnaireId}/revisions`).then(({ data }) => {
            commit('setStateFromResponse', data)
        })
    },
    async deleteQuestionnaireRevision({ commit }, questionnaireRevision) {
        if (confirm(translate("are_you_sure"))) {
            commit("deleteQuestionnaireRevision", questionnaireRevision)
            AxiosWrapper.delete(`/data_api/audit/questionnaires/${questionnaireRevision.id}`)
        }
    },
    async sendForApproval({ commit, dispatch }, { questionnaireRevision, selectedUsers, params }) {
        try {
            let stage = "pending_approval";
            let email_user_ids = selectedUsers.map(user => user.id);
            let send_email_for_approval = true

            // pending_approval
            await AxiosWrapper.patch(`/data_api/v0/audit/revisions/${questionnaireRevision.id}/update_stage`, { stage: stage, email_user_ids: email_user_ids, send_email_for_approval: send_email_for_approval })

            await dispatch('initRevisions', params)

        } catch (error) {

            const errorMessage =
                error?.response?.data?.error || this.translate("there_was_a_problem");

            this.$toast.error(errorMessage, {
                duration: 10000,
            });
        }
    },
    async approveRevision({ commit, dispatch }, { questionnaireRevision, params }) {
        try {
            let stage = "approved";
            let send_email_for_approval = false

            // approved
            await AxiosWrapper.patch(`/data_api/v0/audit/revisions/${questionnaireRevision.id}/update_stage`, { stage: stage, send_email_for_approval: send_email_for_approval })

            await dispatch('initRevisions', params)

        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || this.translate("there_was_a_problem");

            this.$toast.error(errorMessage, {
                duration: 10000,
            });
        }
    },
    async disapproveRevision({ commit, dispatch }, { questionnaireRevision, params }) {
        try {

            let stage = "dis_approved";
            let send_email_for_approval = false

            // disapproved
            await AxiosWrapper.patch(`/data_api/v0/audit/revisions/${questionnaireRevision.id}/update_stage`, { stage: stage, send_email_for_approval: send_email_for_approval })

            await dispatch('initRevisions', params)
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || this.translate("there_was_a_problem");

            this.$toast.error(errorMessage, {
                duration: 10000,
            });
        }
    },
    async makeLive({ commit, state }, { questionnaireRevision, router }) {
        try {
            let stage = "live";
            let send_email_for_approval = false

            // live
            await AxiosWrapper.patch(`/data_api/v0/audit/revisions/${questionnaireRevision.id}/update_stage`, { stage: stage, send_email_for_approval: send_email_for_approval })

            const groupId = state.questionnaire?.audit_questionnaire_group_id;
            router.push(`/audit/questionnaire_groups/${groupId}/questionnaires`);
            //await dispatch('initRevisions', router.params)
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error || this.translate("there_was_a_problem");

            this.$toast.error(errorMessage, {
                duration: 10000,
            });
        }
    },
}
